import styled from "styled-components";
import { breakpoints, maxBreakpoints } from "../../../../shared-logic/themes/toyotaTheme";

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: var(--spacing-3);

    @supports not (row-gap: 0) {
        & > div {
            margin-top: var(--spacing-3);
        }
    }
`;

export const ServicesList = styled.ul`
    display: flex;
    flex-direction: column;
    row-gap: var(--spacing-2);
    margin: 0;
    padding: 0;
    list-style: none;

    @supports not (padding-inline: 0) {
        li:not(:nth-last-child(1)) {
            margin-bottom: var(--spacing-2) !important;
        }
    }
`;

export const MobileIconWrapper = styled.div`
    display: none;
    @media screen and (min-width: ${breakpoints.xl}) {
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;

export const ButtonIconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    @media screen and (min-width: ${breakpoints.xl}) {
        display: none;
    }
`;

export const ButtonText = styled.div`
    @media screen and (max-width: ${maxBreakpoints.md}) {
        display: none;
    }
`;

export const FakeButton = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    user-select: none;

    @media screen and (min-width: ${breakpoints.xl}) {
        padding: calc(var(--spacing-3) / 2) var(--spacing-3);
        border: 1px solid var(--color-primary-black);
    }
`;

export const ServicesButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: var(--spacing-2);
    list-style: none;
    background-color: var(--color-primary-white);
    border: 1px solid var(--color-grey-6);
    border-radius: 4px;
    &::-webkit-details-marker {
        display: none;
    }

    & > div {
        display: inline-flex;
        column-gap: var(--spacing-2);
        align-items: center;
    }

    &:is(:hover, :focus) {
        border-color: var(--color-primary-black);
    }

    @media screen and (min-width: ${breakpoints.xl}) {
        &:active {
            ${FakeButton} {
                color: var(--color-primary-white);
                background-color: var(--color-primary-black);
            }
        }
    }
`;

export const ServiceListItem = styled.li`
    display: flex;
    flex-basis: 100%;
    align-items: center;
    justify-content: center;
    list-style: none;

    summary {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: var(--spacing-2);
        list-style: none;
        background-color: var(--color-primary-white);
        border: 1px solid var(--color-grey-6);
        border-radius: 4px;
        &::-webkit-details-marker {
            display: none;
        }

        & > div {
            display: inline-flex;
            column-gap: var(--spacing-2);
            align-items: center;
        }

        @media screen and (min-width: ${breakpoints.xl}) {
            &:active {
                ${FakeButton} {
                    color: var(--color-primary-white);
                    background-color: var(--color-primary-black);
                }
            }
        }
    }

    details {
        width: 100%;
        &:not([open]):is(:hover, :focus) {
            summary {
                border-color: var(--color-primary-black);
            }
        }

        &[open] {
            background-color: var(--color-grey-1);
            border: 1px solid var(--color-grey-6);
            border-radius: 4px;

            summary {
                border: 0;
                border-bottom: 1px solid var(--color-grey-4);
                border-bottom-left-radius: 0;
                border-bottom-right-radius: 0;
            }

            & > div {
                padding: var(--spacing-3);
            }

            &:is(:hover, :focus) {
                border-color: var(--color-primary-black);
            }
        }
    }
`;
